import React from 'react';

export const MaterialTextarea = ({ className = '', ...props }) => (
  <textarea className={`form-control material ${className}`} {...props} />
);
